import { combineReducers } from 'redux';

import theme from './slices/themeSlice';
import auth from './slices/authSlice';
import userActivity from './slices/userActivitySlice';
import employerSubscription from './slices/employerSubscriptionSlice';
import jobsApplication from './slices/jobsAndApplicationSlice';
import testimonials from './slices/testimonialsSlice';
import companies from './slices/companiesSlice';
import invoices from './slices/invoicesSlice';
import campaigns from './slices/campaignsSlice';
import paymentPackages from './slices/paymentPackagesSlice';

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    userActivity,
    employerSubscription,
    jobsApplication,
    testimonials,
    companies,
    invoices,
    campaigns,
    paymentPackages,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
